module.exports = {
	"abort_transformation": "Abort transformation",
	"actions": "Actions",
	"activity": "Activity",
	"add_layer": "Add layer",
	"add_new_text_element": "Insert text",
	"add_to_collection": "Add to collection",
	"add_to_dashboard": "Add to dashboard",
	"admin": "admin",
	"advanced": "Advanced",
	"aggregation_method": "Aggregation method",
	"aggregation_type": "Aggregation type",
	"aggregation": "Aggregation",
	"akvo_flow": "Akvo Flow",
	"akvo_rsr": "Akvo RSR",
	"all_changes_saved": "All changes saved",
	"all": "All",
	"antimeridian": "Antimeridian",
	"apply": "Apply",
	"area": "Area",
	"ascending": "Ascending",
	"authentication_issue": "There was an issue verifying your identity",
	"autodetect_column_types": "Autodetect column types",
	"average": "Average",
	"back_to_layers": "Back to layers",
	"back": "Back",
	"bar": "Bar",
	"base_map": "Base map",
	"blank_dashboard_help_text": "Click a visualisation in the visualisation list to add it to the dashboard",
	"bottom": "Bottom",
	"bubble": "Bubble",
	"bucket_column": "Bucket column",
	"bulk_column_editor": "Bulk column editor",
	"bulk_row_editor": "Bulk row editor",
	"cancel": "Cancel",
	"categories_cant_be_empty": "Categories can't be empty",
	"categories_count": "{count} {count, plural, one {category} other {categories}}",
	"categories_must_be_unique": "Categories must be unique",
	"category": "Category",
	"cell_as_percentage_of_column": "Cell as percentage of column",
	"cell_as_percentage_of_row": "Cell as percentage of row",
	"cell_as_percentage_of_table_total": "Cell as percentage of table total",
	"change_case": "Change case",
	"change_datatype_for": "Change datatype for {title}",
	"change_datatype_to": "Change dataype to",
	"choose_a_column_to_filter_by": "Choose a column to filter by",
	"choose_a_filter_operation": "Choose a filter operation",
	"choose_a_match_method": "Choose a match method",
	"choose_aggregation_type": "Choose aggregation type",
	"choose_dataset": "Choose dataset",
	"choose_how_cells_are_displayed": "Choose how cells are displayed",
	"circle": "Circle",
	"clear_filter": "Clear filter",
	"close": "Close",
	"collection_name": "Collection Name",
	"collections": "Collections",
	"color_coding_column": "Color coding column",
	"color": "Color",
	"colors_for_title": "Colors ({title})",
	"column_filter_by": "Column to filter by",
	"column_title_geo": "Geo column title",
	"columns_title": "Columns title",
	"columns": "Columns",
	"combine_columns": "Combine columns",
	"combine_transform_description": "Combined columns {firstTitle} and {secondTitle} into \"{newColumnTitle}\"",
	"combine": "Combine",
	"comma": "Comma",
	"contact": "Contact",
	"contains": "contains",
	"count_unique": "Count unique",
	"count": "Count",
	"create_visualization": "Create visualization",
	"create": "Create",
	"created_by": "Created by",
	"creating": "Creating",
	"dashboard": "Dashboard",
	"dashboards": "Dashboards",
	"data_file": "Data File",
	"data_group_intro_0_body": "Datasets are now split into data groups to make it easy to clean and transform your data. Get a better overview regardless of the size of the dataset. A dedicated data group holds all transformed columns to keep things organised.",
	"data_group_intro_0_footer": "In the future, this new view will support data from repeated data groups and become the default.",
	"data_group_intro_0_header": "Experience the new dataset view",
	"data_group_intro_1": "Data groups are based on Flow form question groups and submission metadata. Lumen handles all data relations across the groups when transforming and visualising data.",
	"data_group_intro_2": "Select any data group to show its data on the grid.",
	"data_group_intro_3": "You can toggle between new and old view here.",
	"data_groups": "Data groups",
	"data_has_column_headers": "Data has column headers",
	"data_last_updated": "Data last updated",
	"data": "Data",
	"dataset_filters": "Dataset filters",
	"dataset_name": "Dataset name",
	"dataset": "Dataset",
	"datasets": "Datasets",
	"date": "Date",
	"default": "Default",
	"define_category": "Define category",
	"define_new_category": "Define new category",
	"delete_column": "Delete column",
	"delete_row": "Delete row",
	"delete": "Delete",
	"deleted_column": "Deleted column: {title}",
	"derive_column_category": "Category Column",
	"derive_column_javascript": "Via JavaScript",
	"derive_column": "Derive column",
	"derive": "Derive",
	"derived_category_transform_description": "Derived \"{newColumnTitle}\" from {columnSource} ({columnType})",
	"derived_column_title": "Derived Column Title",
	"derived_transform_description": "Derived {newColumnTitle} using {code}",
	"descending": "Descending",
	"donut": "Donut",
	"download": "Download",
	"drop_file_anywhere": "Drop file anywhere to upload",
	"dropbox": "Dropbox",
	"duplicate": "Duplicate",
	"email_verified_error": "You need to verify your email address. Please check your inbox and click the verification link.",
	"email": "Email",
	"enter_a_number": "Enter a number",
	"enter_password_8": "Please enter a password with at least 8 characters.",
	"enter_password": "Please enter a password.",
	"enter_text_here": "Enter text here",
	"exactly_matches": "exactly matches",
	"export": "Export",
	"extract_multiple_global_error": "Ups, an unexpected error here :!, please contact to the admin",
	"extract_multiple_log": "Extract multiple values from: {extractedColumnTitle} to: {newColumnsTitle}",
	"extract_multiple_not_found_error": "we found a problem with the data inside this multiple column",
	"extract_multiple": "Extract multiple values",
	"extract": "Extract",
	"field_required": "Field required",
	"file_has_column_headers": "File has column headers",
	"file_name": "File name",
	"file_project": "File / Project",
	"fill": "Fill",
	"filter_column": "Filter column {title}",
	"filter_list_by_title": "Filter list by title",
	"filter_match_method": "Filter match method",
	"filter_match_value": "Filter match value",
	"filter_operation": "Filter operation",
	"filter_text": "Filter text",
	"filter_visualisations_by_dataset": "Filter visualisations by dataset",
	"filter": "Filter",
	"filters": "Filters",
	"first_name": "First name",
	"flow_application_url": "Flow Application URL",
	"following_filter_dash_will_be_deleted": "The following dashboard will not be more filtered by the dataset to be deleted",
	"following_filters_dash_will_be_deleted": "The following dashboards will not be more filtered by the dataset to be deleted",
	"following_visualisation_will_be_deleted": "The following visualisation will also be deleted",
	"following_visualisations_will_be_deleted": "The following visualisations will also be deleted",
	"form_submissons": "form submissons",
	"generate_geopoints": "Generate geopoints",
	"generate": "Generate",
	"geo_location": "Geo location",
	"geo_shape": "Geo shape",
	"geo_transform_description": "Generated geopoint column {columnTitleGeo} from columns {columnTitleLat} and {columnTitleLong}",
	"geopoint_column": "Geopoint column",
	"geopoint": "Geopoint",
	"geoshape_column": "Geoshape column",
	"geoshape_labels": "Geoshape labels",
	"geoshape": "Geoshape",
	"geotiff": "GeoTIFF",
	"github": "Github",
	"google_drive": "Google Drive",
	"got_it": "Got it",
	"gradient": "Gradient",
	"greenwich": "Greenwich",
	"group": "Group",
	"having_trouble_signing_up": "Having trouble signing up?",
	"horizontal": "Horizontal",
	"hyphen": "Hyphen",
	"if_cell_format_is_invalid": "If cell format is invalid",
	"if_transformation_fails": "If transformation fails",
	"Image": "Image",
	"import": "Import",
	"invalid_expression": "Invalid expression",
	"invalid_filter": "This visualisation contains an invalid filter and cannot be displayed.",
	"is_after": "is after",
	"is_before": "is before",
	"is_empty": "is empty",
	"is_equal_to": "is equal to",
	"is_greater_or_equal_to": "is greater than or equal to",
	"is_greater_than": "is greater than",
	"is_higher_than": "is higher than",
	"is_less_or_equal_to": "is less than or equal to",
	"is_less_than": "is less than",
	"is_lower_than": "is lower than",
	"javascript_code": "Javascript code",
	"js_helptext": "Derived columns are formulas written using a subset of Javascript where a single expression is allowed and columns are referenced as {columnSyntax} or alternatively if the title is a valid javascript identifier: {title}.",
	"keep_rows_in_which": "keep rows in which",
	"label": "Label",
	"last_modified": "Last modified",
	"last_name": "Last name",
	"latitude_column": "Latitude column",
	"layer_type": "Layer type",
	"layers": "Layers",
	"leave_cell_empty": "Leave cell empty",
	"left": "Left",
	"legend_category_order": "Category order",
	"legend_order_auto_mode": "Auto",
	"legend_order_custom_mode": "Custom",
	"legend_position_auto": "Auto",
	"legend_position_bottom": "Bottom",
	"legend_position_left": "Left",
	"legend_position_right": "Right",
	"legend_position_top": "Top",
	"legend_position": "Legend position",
	"legend_title": "Legend title",
	"legend": "Legend",
	"library": "Library",
	"line": "Line",
	"link": "Link",
	"logout": "logout",
	"longitude_column": "Longitude column",
	"lower_quartile": "Lower quartile",
	"main": "Main",
	"map": "Map",
	"max_value": "Max: {val}",
	"max": "Max",
	"mean": "Mean",
	"median": "Median",
	"merge_datasets": "Merge datasets",
	"merged_dataset": "Merged columns from {title}",
	"metadata": "Metadata",
	"metric_column": "Metric column",
	"metric_columns": "Metric columns",
	"min_value": "Min: {val}",
	"min": "Min",
	"misc": "Other options",
	"multiple": "Multiple values",
	"must_choose_bucket_column_first": "Must choose bucket column first",
	"must_choose_x_axis_column_first": "Must choose X-axis column first",
	"name": "Name",
	"new_category_column": "New Category Column",
	"new_collection": "New collection",
	"new_column_title": "New column title",
	"new_column_type": "New column type",
	"new_dataset": "New Dataset",
	"new_filter": "New filter",
	"new_serie": "New serie",
	"next": "Next",
	"no_filter_dashboards_depend_on_dataset": "No filters dashboards depend on this datataset",
	"no_visualisations_depend_on_dataset": "No visualisations depend on this datataset",
	"no_visualisations_match_your_filter": "No visualisations match your filter",
	"no_visualisations_to_show": "No visualisations to show",
	"none": "None",
	"not_affected_by_applied_filters": "Not affected by applied filters",
	"not_contains": "not contains",
	"number_of_buckets_to_show": "Number of buckets to show",
	"number_of_decimal_places": "Number of decimal places",
	"number": "Number",
	"option": "Option",
	"or": "or",
	"outline": "Outline",
	"overflow": "Overflow",
	"paste_url_here": "Paste url here",
	"pattern_subtitle": "Specify any character (or string of characters) to split the column by.",
	"pattern_suggestion": "Suggestions for '{columnTitle}': {recommendations}",
	"pattern": "Separator",
	"pdf": "PDF",
	"pending": "Pending",
	"percentage_stack_bars": "Percentage Stack Bars",
	"pick_a_default_value": "Pick a default value",
	"pie": "Pie",
	"pivot table": "Pivot table",
	"pivot_help_text": "Choose a column and a row to pivot on to use aggregations other than count.",
	"please_edit_visualisation": "Please edit the visualisation or add a filter.",
	"png": "PNG",
	"point_size": "Point size",
	"polararea": "Polar Area",
	"popup_label_column": "Popup label column",
	"popup_label": "Popup label",
	"popup": "Popup",
	"prefix": "New column prefix",
	"previous": "Previous",
	"raster": "Raster",
	"remove_collection": "Remove from {title}",
	"remove_double_space": "Remove double space",
	"remove_leading_and_trailing_whitespace": "Remove leading and trailing whitespace",
	"remove_rows_in_which": "remove rows in which",
	"removed_double_space": "{title} removed double space",
	"rename_column": "Rename column",
	"rename": "Rename",
	"renamed_column": "Renamed {from} to {to}",
	"request_permission_from_your_organisation_admin": "Request permission from your organisation admin.",
	"reselect_source_column": "Pick another column",
	"resources": "Resources",
	"retry": "Retry",
	"reverse_geocode": "Reverse geocode",
	"right": "Right",
	"role": "Role",
	"row_column_title": "Row column title",
	"row_column": "Row column",
	"rows": "Rows",
	"rqg": "Multiple",
	"satellite": "Satellite",
	"save_filter": "Save filter",
	"save_your_dashboard_before_exporting": "Save your dashboard before exporting",
	"save_your_dashboard_before_sharing": "Save your dashboard before sharing",
	"save_your_visualisation_before_exporting": "Save your visualisation before exporting",
	"save_your_visualisation_before_sharing": "Save your visualisation before sharing",
	"save": "Save",
	"saving_failed_countdown": "Saving failed. Retrying ",
	"scatter": "Scatter",
	"search_not_implemented_yet": "Search not implemented yet",
	"search": "Search",
	"select_a_color_coding_column": "Select a data column to color points by",
	"select_a_column": "Select a column",
	"select_a_data_column_to_group_by": "Select a data column to group by",
	"select_a_geopoint_column": "Select a geopoint column",
	"select_a_geoshape_column": "Select a geoshape column",
	"select_a_geoshape_label_column": "Select a geoshape label column",
	"select_a_latitude_column": "Select a latitude column",
	"select_a_longitude_column": "Select a longitude column",
	"select_a_metric_column": "Select a metric column",
	"select_a_popup_label_column": "Select a popup label column",
	"select_a_row_column": "Select a row column",
	"select_a_styling_dataset": "Select a styling dataset",
	"select_a_styling_indicator_geopoint_column": "Select a styling indicator geopoint column",
	"select_a_styling_indicator": "Select a styling indicator",
	"select_a_sub_bucket_column": "Select a sub-bucket column",
	"select_a_value_column": "Select a value column",
	"select_aggregation_method": "Select aggregation method",
	"select_all": "Select all",
	"select_another_metric_column": "Select another metric column",
	"select_column_lat": "Select latitude column",
	"select_column_long": "Select longitude column",
	"select_form": "Select Form",
	"select_multiple_column": "Select multiple column",
	"select_n_column": "Select {idx, selectordinal, one {#st} two {#nd}} column",
	"select_separator": "Select separator",
	"select_source_column": "Select source column",
	"select_survey_or_folder": "Select Survey or Folder",
	"select_values_to_extract": "Select values to extract",
	"select_values_to_group": "Select values to group",
	"select": "Select",
	"set_dataset_columns_as_visualisation_filters": "Set dataset columns as visualisation filters",
	"set_permissions": "Set permissions",
	"settings": "Settings",
	"share": "Share",
	"show_column_totals": "Show column totals",
	"show_labels": "Show labels",
	"show_legend": "Show legend",
	"show_row_totals": "Show row totals",
	"show_rows_whose": "Show rows whose",
	"size_label": "Size label",
	"size": "Size",
	"skip": "Skip",
	"solid": "Solid",
	"sort": "Sort",
	"sorted_column": "{title} sorted {direction, select, ASC {ascending} DESC {descending}}",
	"source_column": "Source column",
	"source_dataset": "Source dataset",
	"source": "Source",
	"split_bars": "Split bars",
	"split_bucket": "Split bucket",
	"split_column_log": "Split column '{extractedColumnTitle}', with prefix '{newColumnNamePrefix}' with separator '{pattern}'",
	"split_column": "Split column values",
	"square": "Square",
	"stack_bars": "Stack bars",
	"street": "Street",
	"styling_dataset": "Styling dataset",
	"styling_indicator_geopoint_column": "Styling indicator geopoint column",
	"styling_indicator": "Styling indicator",
	"sub_bucket_column": "Sub-bucket column",
	"sub_bucket_method": "Sub-bucket method",
	"sum": "Sum",
	"switch_view": "Switch view",
	"terrain": "Terrain",
	"text": "Text",
	"theme": "Theme",
	"to_lowercase_label": "To lowercase",
	"to_lowercase": "{title} to lowercase",
	"to_titlecase_label": "To titlecase",
	"to_titlecase": "{title} to titlecase",
	"to_try_with_another_account": "to try with another account",
	"to_uppercase_label": "To uppercase",
	"to_uppercase": "{title} to uppercase",
	"too_many_visualisation_elements": "This visualisation cannot be displayed because it has {count} elements. The maximum number of elements is {max}.",
	"top": "Top",
	"transform": "Transform",
	"transformation_log": "Transformation log",
	"transformations": "Transformations",
	"triangle": "Triangle",
	"trimmed_whitespace": "{title} trimmed whitespace",
	"type_javascript_expression_here": "Type javascript expression here",
	"uncategorized_values": "Uncategorized values",
	"uncategorized": "Uncategorized",
	"undo": "Undo",
	"unique_values_count": "{count} unique {count, plural, one {value} other {values}}",
	"unsaved_changes": "Unsaved changes",
	"untitled_collection": "Untitled collection",
	"untitled_dashboard": "Untitled dashboard",
	"untitled_layer": "Untitled layer {count}",
	"untitled_visualisation": "Untitled visualisation",
	"update": "Update",
	"upper_quartile": "Upper quartile",
	"user": "User",
	"users": "Users",
	"using_sampled_data": "Using sampled data",
	"value_column": "Value column",
	"value_contains": "Value contains",
	"value_display": "Value display",
	"value_is": "Value is",
	"view_details": "View details",
	"visualisation_type": "Type",
	"visualisation": "Visualisation",
	"visualisations_that_can_be_filtered": "Visualizations that can be filtered by selected dataset",
	"visualisations": "Visualisations",
	"visualise": "Visualise",
	"whitespace": "Whitespace",
	"world_bank": "World Bank",
	"x_axis_label": "X-axis label",
	"x_axis": "X-axis",
	"y_axis_label": "Y-axis label",
	"y_axis": "Y-axis",
	"yikes": "Yikes",
	"you_need_permission_to_access": "You need permission to access"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 352
// module chunks = 11 12